import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StudentsNavGrid from '../../components/StudentsNavGrid/StudentsNavGrid';
import Modal from '../../components/Modal/Modal';
import styles from './StudentsNavModal.module.scss';

export default class StudentsNavModal extends Component {
  render() {
    const { isOpen, handleClose, projects } = this.props;

    return (
      <Modal isOpen={isOpen} handleClose={handleClose}>
        <div className={styles.studentsNavModal}>
          <StudentsNavGrid projects={projects} />
        </div>
      </Modal>
    );
  }
};

StudentsNavModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  projects: PropTypes.array
};



// WEBPACK FOOTER //
// ./src/components/StudentsNavModal/StudentsNavModal.jsx